import { sendGTMEvent } from "@next/third-parties/google";
import Cookies from "js-cookie";

export function addOrReplaceLanguage(
  url: string | undefined,
  language: string,
) {
  if (!url) {
    return "";
  }

  const regex = /\/[a-zA-Z]{2}\//;

  if (regex.test(url)) {
    return url.replace(regex, `/${language}/`);
  }

  let urlParts = url.split("/");

  urlParts.splice(3, 0, language);

  return urlParts.join("/");
}

export function getLandingPageKeyFromUrl(url: string | undefined): string {
  if (!url) {
    return "";
  }

  return url.split("/").pop() || "";
}

export function sendEvent(data: Object) {
  Cookies.get("_ga") && sendGTMEvent(data);
}

/**
 * Text Formatter - String input To Title Case
 * @param str String to format
 * @returns: string - Formatted string
 */
export const toTitleCase = (str: string): string =>
  str.replace(
    /\w\S*/g,
    txt => `${txt.charAt(0).toUpperCase()}${txt.slice(1).toLowerCase()}`,
  );

/**
 * String input capitalize first letter
 * @param str String to format
 * @returns string - reformatted string
 */
export const uppercaseFirstChar = (str: string): string =>
  str.charAt(0).toUpperCase() + str.slice(1);

/**
 * It creates a delay effect to avoid a loading spinner to disappear too quickly
 * @param ms
 * @returns
 */
export function sleep(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
